import type { LabOrderWizardPrefill } from '../model/labOrderWizardPrefill.js';

import { LegacyLabOrderWizard } from './LegacyLabOrderWizard.js';
import { NativeLabOrderWizard } from './NativeLabOrderWizard.js';

interface LabOrderWizardProps {
  userId: string;
  prefill: LabOrderWizardPrefill | null;
}

export function LabOrderWizard({ userId, prefill }: LabOrderWizardProps) {
  if (prefill?.type === 'existing_test') {
    return <LegacyLabOrderWizard userId={userId} prefill={prefill} />;
  }

  return <NativeLabOrderWizard userId={userId} prefill={prefill} />;
}
